<script setup>

import { ref, computed, watch, inject, nextTick } from 'vue';

import { apiModifierTextesBriquesRapport } from '@/services/ServiceModele.js';
import { getPositionBriqueRapport } from '@/scripts/global';

const { zone, texte, modeEdition } = defineProps({
	zone: Object,
	texte: Object,
	modeEdition: Boolean
});

const emit = defineEmits(['activationModeEdition', 'desactivationModeEdition']);

const composantSaisieTexte = ref(null);
const texteSaisi = ref(texte.texte);
const indiceExpressionSelectionnee = ref(-1);

const nbLignes = computed(() => {
	return texteSaisi.value.split('\n').length;
});

watch(() => texte, (elementTexte) => {
	texteSaisi.value = elementTexte.texte;
});

watch(() => modeEdition, (edition) => {
	if (edition) {
		nextTick(() => {
			composantSaisieTexte.value.select();
		});
	} else {
		texteSaisi.value = texte.texte;
	}
});

watch(() => texte.selectionne, (selection) => {
	if (!selection) {
		indiceExpressionSelectionnee.value = -1;
	}
});

const selectionnerElement = inject('selectionnerElement');
const selectionnerCalculable = inject('selectionnerCalculable');
const appelerApiModifModele = inject('appelerApiModifModele');

function selectionnerExpression(indiceExpression) {
	if (!texte.selectionne) {
		selectionnerElement(texte, zone);
	}
	const expression = texte.expressions[indiceExpression].expression;
	const positionBrique = {
		type: 'ExpressionDansTexte', 
		positionSection: texte.positionSection, 
		positionDansSection: texte.positionDansSection, 
		positionDansElement: [indiceExpression]
	};
	selectionnerCalculable(positionBrique, expression);
	indiceExpressionSelectionnee.value = indiceExpression;
}

function deselectionnerExpression() {
	indiceExpressionSelectionnee.value = -1;
}

function insererRetourChariot() {
	const positionCurseur = composantSaisieTexte.value.selectionStart;
	const texteAvantCurseur = texteSaisi.value.substring(0, positionCurseur);
	const texteApresCurseur = texteSaisi.value.substring(positionCurseur + 1);
	texteSaisi.value = `${texteAvantCurseur}\n${texteApresCurseur}`
}

function modifierTexte() {
	const infosBriqueRapport = {
		positionBrique: getPositionBriqueRapport(texte, zone),
		texte: texteSaisi.value
	};
	appelerApiModifModele(apiModifierTextesBriquesRapport, [infosBriqueRapport], (reponseOK) => {
		if (reponseOK) {
			emit('desactivationModeEdition');
		}
	});
}

</script>

<template>
	<div v-if="!modeEdition" 
		class="texte" 
		:style="texte.style"
		@click="deselectionnerExpression()"
		@dblclick="emit('activationModeEdition')">
		<template v-for="briqueTexte in texte.briquesTexte">
			<span v-if="briqueTexte.type === 'TexteExpression'" 
				class="expression brique-texte"
				:class="{selectionne: briqueTexte.indiceExpression === indiceExpressionSelectionnee}"
				@click.stop="selectionnerExpression(briqueTexte.indiceExpression)">
				{{ briqueTexte.texte }}
			</span>
			<span v-else class="brique-texte">{{ briqueTexte.texte }}</span>
		</template>
	</div>
	<textarea v-else
		ref="composantSaisieTexte"
		v-model="texteSaisi" 
		:style="texte.style"
		:rows="nbLignes" cols="50"
		@click.stop=""
		@dragstart.stop.prevent=""
		@dragleave.stop.prevent=""
		@keydown.enter.exact.prevent="modifierTexte()"
		@keydown.enter.shift.exact.prevent="insererRetourChariot()"
		@keydown.escape.prevent.stop="$emit('desactivationModeEdition')" 
		@blur="$emit('desactivationModeEdition')" />
</template>

<style scoped>

.texte {
	user-select: none;
	white-space: pre-wrap;
	border-style: solid;
	border-width: 0px;
	padding: 5px;
}

.expression:hover {
	background-color: lightgrey;
}

.selectionne {
	background-color: lightgrey;
}

.brique-texte {
	font-weight: inherit;
}

</style>